import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EDocsActions, EDocsActionTypes } from './edocs.actions';
import { EDocs, EDocsFile, EDocsFolder } from './edocs.models';

interface EDocsState {
  eDocs: EDocs;
  selectedFile: EDocsFile;
  selectedFolder: EDocsFolder;
}

export const eDocsInitialState: EDocsState = {
  eDocs: undefined,
  selectedFile: undefined,
  selectedFolder: undefined
};

export function eDocsReducer(
  state = eDocsInitialState,
  action: EDocsActions
): EDocsState {
  switch (action.type) {
    case EDocsActionTypes.LOAD_EDOCS:
      return { ...state, eDocs: void 0 };

    case EDocsActionTypes.LOAD_EDOCS_SUCCESS:
      return { ...state, eDocs: action.payload };

    case EDocsActionTypes.SELECT_FILE:
      return {
        ...state,
        selectedFolder: void 0,
        selectedFile: action.payload
      };

    case EDocsActionTypes.SELECT_FOLDER:
      return {
        ...state,
        selectedFile: void 0,
        selectedFolder: action.payload
      };

    case EDocsActionTypes.CREATE_FILE:
      return {
        ...state,
        selectedFile: void 0,
        selectedFolder: void 0
      };

    case EDocsActionTypes.CREATE_FOLDER:
      return {
        ...state,
        selectedFile: void 0,
        selectedFolder: void 0
      };

    default:
      return state;
  }
}

const eDocsState = createFeatureSelector<EDocsState>('eDocs');

export const selectorEDocsEDocs = createSelector(
  eDocsState,
  state => state.eDocs
);

export const selectorEDocsSelectedFile = createSelector(
  eDocsState,
  state => state.selectedFile
);

export const selectorEDocsSelectedFolder = createSelector(
  eDocsState,
  state => state.selectedFolder
);
